var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center match-height"},_vm._l((_vm.programs),function(program){return _c('b-col',{key:program.id},[_c('program-card-array',{attrs:{"program":program}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }